import { z } from 'zod'

export const idleSignInFormSchema = z.object({
  email: z.string().email(),

  password: z.string().min(1, { message: 'Campo obrigatório' }),
})

export type IdleSignInFormSchema = z.infer<typeof idleSignInFormSchema>
